import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Logo-TRU-web.png")